import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhoneFormatService {

  constructor() {}

  formatSwedishPhoneNumber(input: string): string {
    if (!input) return '';

    // Remove everything except digits and plus sign
    let digits = input.replace(/[^\d+]/g, '');

    // Enforce starts with +46
    if (!digits.startsWith('+46')) {
      digits = '+46' + digits.replace(/^\+?46/, '');
    }

    // Remove +46 to format rest of number
    let rest = digits.slice(3).replace(/\D/g, '');

    // Format groups: 3, 3, 2, 2 digits
    let part1 = rest.slice(0, 3);
    let part2 = rest.slice(3, 6);
    let part3 = rest.slice(6, 8);
    let part4 = rest.slice(8, 10);

    let formatted = '+46';
    if (part1) formatted += ' ' + part1;
    if (part2) formatted += ' ' + part2;
    if (part3) formatted += ' ' + part3;
    if (part4) formatted += ' ' + part4;

    return formatted.trim();
  }
}
